import { DateUnits, Selectors, Operators, Sex } from './enums';

export const getAllDateUnits = () => {
    return [
        { name: 'Days', value: DateUnits.DAYS },
        { name: 'Weeks', value: DateUnits.WEEKS },
        { name: 'Months', value: DateUnits.MONTHS },
        { name: 'Years', value: DateUnits.YEARS },
    ];
};

export const getAllSelectors = () => {
    return [
        { name: 'first', value: Selectors.FIRST },
        { name: 'last', value: Selectors.LAST },
        { name: 'any', value: Selectors.ANY },
    ];
};

export const getAllOperators = () => {
    return [
        { name: 'Equals to', value: Operators.EQ },
        { name: 'Less than', value: Operators.LT },
        { name: 'Greater than', value: Operators.GT },
        { name: 'Less than or Equals to', value: Operators.LTE },
        { name: 'Greater than or Equals to', value: Operators.GTE },
    ];
};

export const getAllSexes = () => {
    return [
        { id: 1, name: 'Male', value: Sex.MALE },
        { id: 2, name: 'Female', value: Sex.FEMALE },
    ];
};


export const getUserStatuses = () => {
    return [
        { id: 1, name: 'Include all' },
        { id: 2, name: 'Exclude archived (Active only)' },
        { id: 3, name: 'Archived only' },
    ];
};
